import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=5d7ea69c"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7ea69c')) {
      api.createRecord('5d7ea69c', component.options)
    } else {
      api.reload('5d7ea69c', component.options)
    }
    module.hot.accept("./index2.vue?vue&type=template&id=5d7ea69c", function () {
      api.rerender('5d7ea69c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/index2.vue"
export default component.exports